<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" style="background-color: white">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs" style="margin: 0 !important;padding: 0 !important;width:100%">
      <div style="width: 100%;float: left;margin-bottom: 15px">
        <span style="width: 240px;float: left;margin-left: 100px;"><img src="@/assets/img/logo.png" style="width: 230px;height: 85px;margin-top: 15px"></span>
        <span style="margin-left: 100px;padding-top: 30px;float: left;font-size: 35px;font-weight: 800;color: RGB(137,159,216)"><i class="el-icon-phone"/>028-6131-1003</span>
        <span style="margin-left: 200px;padding-top: 35px;float: left;"><el-input style="width: 80%;height: 50px;border-radius: 0" v-model="searchValue" placeholder="请输入您要搜索的关键词" /><el-button  slot="append" icon="el-icon-search"  style="width: 20%;background-color: RGB(24,14,177);border:RGB(24,14,177);color: #ffffff;border-radius: 0 " @click="search"/></span>
      </div>
      <!-- 导航logo -->
<!--      <div class="header-nav-logo">-->

<!--      </div>-->
      <!-- 导航内容 -->
      <div style="background: RGB(80,138,245);width: 100%;float: left">
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="[index==navIndex?'active':'']"
           @click="navClickPC(index,item)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n" @click.stop="subNavClick(i, index)" :class="[subIndex==i.path?'active':'']">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>

          </dl>
        </li>
      </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in mNavList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name,item.path)"
            data-toggle="collapse"
            data-target="#menu"
          >
<!--            <router-link :to="item.path">-->
              {{item.name}}
              <i class="underline"></i>
<!--            </router-link>-->
          </li>
          <li style="font-size: 15px"><img style="display: inline-block; width: 18px;height: 18px;" src="@/assets/img/phone.png"/>028-6131 1003</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      subIndex: '',
      menuName: "国盈首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "国盈首页",
          path: "/",
          children: []
        },
        // {
        //   name: "核心产品",
        //   path: "",
        //   children: [
        //     {
        //       name: '鼎竑青龙漏洞管控平台',
        //       path: '/ld'
        //     },
        //     {
        //       name: '鼎竑白虎网络欺骗诱捕系统',
        //       path: '/mg'
        //     },
        //     {
        //       name: '鼎竑朱雀数据库审计系统',
        //       path: '/ss'
        //     },
        //     {
        //       name: '鼎竑朱雀日志审计系统',
        //       path: '/rs'
        //     },
        //   ]
        // },
        {
          name: "保函案例",
          path: "/case",
          children: [
            {
              name: "民工工资担保",
              path: "/case?id=3"
            },
            {
              name: "履约担保",
              path: "/case?id=2"
            },
            {
              name: "质量担保",
              path: "/case?id=5"
            },
            {
              name: "预付款担保",
              path: "/case?id=4"
            }
          ]
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "保函查询",
          path: "/guarantee",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/news",
          children: []
        },
        {
          name: "寻求合作",
          path: "/cooperation",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ],
      mNavList: [
        {
          name: "国盈首页",
          path: "/",
          children: []
        },
        // {
        //   name: '鼎竑白虎网络欺骗诱捕系统',
        //   path: '/mg'
        // },
        // {
        //   name: '鼎竑青龙漏洞管控平台',
        //   path: '/ld'
        // },
        // {
        //   name: '鼎竑朱雀数据库审计系统',
        //   path: '/ss'
        // },
        // {
        //   name: '鼎竑朱雀日志审计系统',
        //   path: '/rs'
        // },
        // {
        //   name: "金融行业威胁防护方案",
        //   path: "/fin"
        // },
        // {
        //   name: "电力行业攻击防御方案",
        //   path: "/ele"
        // },
        // {
        //   name: "交通行业数据安全解决方案",
        //   path: "/trans"
        // },
        // {
        //   name: "鼎竑等保合规解决方案",
        //   path: "/dengbao"
        // },
        {
          name: "保函查询",
          path: "/guarantee",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/news",
          children: []
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: []
        }
      ],
      searchValue:null
    };
  },
  methods: {
    navClick(index, name, path) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      this.subIndex = '';
      this.$router.push({path:path});
    },
    navClickPC(index, item) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = item.name;
      this.subIndex = '';
      let name = item.path.substr(1,item.path.length);
      if(null != name && "" !== name){
        this.$router.push({name:name,path:item.path});
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    subNavClick(n, i) {
      this.subIndex = n.path;
      this.navIndex = i;
      sessionStorage.setItem('navIndex',i);
    },
    search(){
      this.$router.push({name:'search',path:'/search',query:{search:this.searchValue}});
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 60px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 140px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 135px;
  height: 35px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  background: RGB(80,138,245);
  line-height: 80px;
}
#header .header-nav .header-nav-wrapper {
  width: 100%;
  line-height: 80px;
  /*float: right;*/
  margin-left: 10%;
  /*max-width: 800px;*/
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0;
  /*padding: 0 35px;*/
  position: relative;
  width: 170px;
  text-align: center;
  cursor: pointer;
}
#header .header-nav .header-nav-wrapper > li:hover {
  background-color: RGB(60,112,221);
}
  /* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: white;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  /*background-color: #BA271A;*/
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  /*color: #BA271A;*/
  color: white;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: white;
  text-decoration: none;
  /*border-bottom: 2px solid #BA271A;*/
}
#header .header-nav .header-nav-wrapper dt.active  a {
  color: #BA271A;
  text-decoration: none;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 170px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  height: 50px;
  padding-top: 15px;
  border-bottom: 1px solid #ccc;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover{
  background: RGB(80,138,245);
  color: white !important;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: black !important;
  width: 100%;
  height: 100%;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #ffffff !important;
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: RGB(80,138,245);
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 135px;
    height: 35px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #190000;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #190000;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue